export enum TabNames {
  Properties = "Properties",
  SelectedProperties = "SelectedProperties",
}

export enum PropertyTabNames {
  ShortListedProperties = "Short Listed Properties",
  SearchProperties = "Search Properties",
}

export enum FurnishingDetailsViewOption {
  SinglePage = 'SinglePage',
  TwoColumn = 'TwoColumn',
  ThreeColumn = 'ThreeColumn',
}
